__webpack_require__.p = "https://belajar-cdn-fe.guru.production.belajar.id/_next/";